import request from '@/utils/request'

const url = 'admin/bank_info'
/**
 * 银行信息表接口API
 */

const api = {
    Query(data) {
        return request({
          url: `${url}/list`,
          method: 'post',
          data
        })
    },
    
    /**
     * 添加BankInfo
     * @returns
     */
    Create(data) {
        return request({
          url: `${url}/createOrUpdate`,
          method: 'post',
          data
        })
    },

    /**
     * 编辑BankInfo
     * @returns
     */
    Update(data) {
        return request({
          url: `${url}/createOrUpdate`,
          method: 'post',
          data
        })
    },

    /**
     * 详情BankInfo
     * @returns
     */
    Detail(id) {
        return request({
          url: `${url}/detail`,
          method: 'post',
          params: { id }
        })
    },

    /**
     * 删除BankInfo
     * @returns
     */
    Delete(data) {
        return request({
          url: `${url}/destroy`,
          method: 'post',
          data
        })
    },

  /**
   * 导出BankInfo数据
   * @returns
   */
  Export(data) {
      return request({
        url: `${url}/export`,
        method: 'post',
        data
      })
  },

  /**
   * 获取父级银行
   * @returns
   */
  getParentBank(data){
    return request({
      url: `${url}/getParentBank`,
      method: 'post',
      data
    })
  }
}

export default api
